import { render } from "./user_form.vue?vue&type=template&id=2017d04a"
import script from "./user_form.vue?vue&type=script&lang=js"
export * from "./user_form.vue?vue&type=script&lang=js"
script.render = render

export default script